import React from 'react'
import PropTypes from 'prop-types'
import { Container, Day, DayName, DayNumber } from './styled'
import FlexHorizontalDrag from '@/components/Draggers/FlexHorizontalDrag'

interface Props {
  variant: string
  setDay: (day: number) => void
  selectedDay: number
  days: Array<{ name: string; number: string }>
}

const Days: React.FC<Props> = React.forwardRef(
  ({ variant, days, setDay, selectedDay }, ref) => (
    <Container ref={ref}>
      <FlexHorizontalDrag parentRef={ref}>
        <>
          {days.map(({ name, number }) => {
            const isSelected = selectedDay === parseInt(number, 10)
            const className = isSelected ? 'selected noSelect' : 'noSelect'
            return (
              <Day
                key={number}
                variant={isSelected ? `${variant}Selected` : variant}
                className={className}
                onPointerDown={() => setDay(parseInt(number, 10))}
              >
                <DayName className={className} data-url>
                  {name.substring(0, 3)}
                </DayName>
                <DayNumber className={className} data-url>
                  {number}
                </DayNumber>
              </Day>
            )
          })}
        </>
      </FlexHorizontalDrag>
    </Container>
  ),
)

Days.defaultProps = {
  variant: 'light',
}

Days.propTypes = {
  selectedDay: PropTypes.number.isRequired,
  setDay: PropTypes.func.isRequired,
  variant: PropTypes.oneOf(['dark', 'light']),
}

export default Days
